import { useMemo, useState } from 'react';

import { useAuth } from '@features/auth/hooks/useAuth';
import { ClubsList } from '@features/club/ui/ClubsList/ClubsList';
import { useClubsListQuery } from '@features/shared/api/public';

export function ClubsListWidget() {
  const [query, setQuery] = useState('');
  const user = useAuth().user;
  const myClubIds = useMemo(() => {
    return user ? Object.keys(user.clubs) : [];
  }, [user]);

  const {
    data: clubs,
    fetchNextPage,
    hasNextPage,
    isPending,
  } = useClubsListQuery({
    query,
    limit: 30,
  });

  return (
    <ClubsList
      clubs={clubs}
      query={query}
      onQueryChange={setQuery}
      isLoading={isPending}
      onLoadMore={hasNextPage ? fetchNextPage : undefined}
      myClubIds={myClubIds}
    />
  );
}
